module.exports = __webpack_public_path__ + "static/img/13.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/13.png
// module id = jKqr
// module chunks = 0